import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import React from "react";
import { getFormElementType } from "utilities/freefieldUtils";

interface Props {
  value: server.dto.FormElementTypes;
  onChange: (value: server.dto.FormElementTypes) => void;
}

export const FreeFieldTypeRadio = (props: Props) => {
  return <RadioGroup
    orientation="vertical"
    options={[
      { label: getFormElementType("boolean").text, value: "boolean" },
      { label: getFormElementType("booleanNullable").text, value: "booleanNullable" },
      { label: getFormElementType("date").text, value: "date" },
      { label: getFormElementType("dateTime").text, value: "dateTime" },
      { label: getFormElementType("decimal").text, value: "decimal" },
      { label: getFormElementType("dropdown").text, value: "dropdown" },
      { label: getFormElementType("email").text, value: "email" },
      { label: getFormElementType("integer").text, value: "integer" },
      { label: getFormElementType("percentage").text, value: "percentage" },
      { label: getFormElementType("textMultiLine").text, value: "textMultiLine" },
      { label: getFormElementType("textSingleLine").text, value: "textSingleLine" },
      { label: getFormElementType("time").text, value: "time" },
      { label: getFormElementType("url").text, value: "url" },
    ]}
    value={props.value}
    onChange={props.onChange}
  />
}

export const canModifyFieldType = (type: server.dto.FormElementTypes) =>
  ["date", "dateTime", "textSingleLine", "textMultiLine"].includes(type);

export const FreeFieldModifyRadio = (props: Props) => {
  if (["date", "dateTime"].includes(props.value)) {
    return <RadioGroup
      orientation="horizontal"
      options={[
        { label: getFormElementType("date").text, value: "date" },
        { label: getFormElementType("dateTime").text, value: "dateTime" },
      ]}
      value={props.value}
      onChange={props.onChange}
    />
  } else if (["textSingleLine", "textMultiLine"].includes(props.value)) {
    return <RadioGroup
      orientation="horizontal"
      options={[
        { label: getFormElementType("textSingleLine").text, value: "textSingleLine" },
        { label: getFormElementType("textMultiLine").text, value: "textMultiLine" },
      ]}
      value={props.value}
      onChange={props.onChange}
    />
  }

  return null;
}